import { loadVGSCollect as x } from "./index9.mjs";
import e, { useState as i, useEffect as A } from "react";
import o from "./index10.mjs";
import { VGS_ACTION_ENDPOINT as D, CC_NAME_ID as G, CC_NUMBER_ID as k, CC_EXPIRATION_ID as q, CC_CVC_ID as F } from "./index11.mjs";
import { VGSCollectProvider as T, VGSCollectForm as _ } from "./index12.mjs";
import { StripeButton as P } from "./index13.mjs";
import { TosElementWithBanner as L } from "./index14.mjs";
const {
  TextField: O,
  CardNumberField: B,
  CardExpirationDateField: M,
  CardSecurityCodeField: R
} = _, c = ({ label: r, required: l, children: a }) => /* @__PURE__ */ e.createElement("div", { className: o.field }, /* @__PURE__ */ e.createElement("div", null, r, l ? /* @__PURE__ */ e.createElement("span", null, "*") : null), a), w = (r, l = "sandbox") => {
  const [a, n] = i(!1);
  return A(() => {
    (async () => {
      try {
        await x({
          vaultId: r,
          environment: l,
          version: "2.14.0"
        }), n(!0);
      } catch (s) {
        console.error("Failed to load VGSCollect", s);
      }
    })();
  }, [r, l]), {
    isCollectScriptLoaded: a
  };
}, K = ({
  vaultId: r,
  environment: l,
  onSubmit: a,
  onError: n,
  showTermsAndConditions: m,
  showSalesTerms: s,
  onAcceptSalesTerms: u
}) => {
  const { isCollectScriptLoaded: f } = w(r, l), [p, b] = i(!1), [E, d] = i(!1), [y, I] = i(!0), S = (t) => {
    b(t), u && u(t);
  }, h = (t) => {
    t ? a(t) : n();
  }, N = (t) => {
    (t !== null ? Object.values(t).every((v) => v.isValid) : !1) && I(!1);
  }, V = (t, C) => {
    d(!0), p && h(C);
  }, g = (t) => {
    d(!0), n(t);
  };
  return f ? /* @__PURE__ */ e.createElement(T, null, /* @__PURE__ */ e.createElement(
    _,
    {
      vaultId: r,
      environment: l || "sandbox",
      action: D,
      submitParameters: {
        headers: {
          "x-application": "MyApplication 2.8.3"
        }
      },
      onSubmitCallback: V,
      onUpdateCallback: N,
      onErrorCallback: g
    },
    /* @__PURE__ */ e.createElement(
      L,
      {
        tncAccepted: p,
        setTncAccepted: S,
        showSalesTerms: s,
        showTermsAndConditions: m,
        hasAttemptedPayment: E,
        setHasAttemptedPayment: d
      }
    ),
    /* @__PURE__ */ e.createElement(
      c,
      {
        label: I18n.t("payment_frontend.cards_holder_name"),
        required: !0
      },
      /* @__PURE__ */ e.createElement(
        O,
        {
          className: o["field-input"],
          name: G,
          placeholder: I18n.t("payment_frontend.cards_holder_name"),
          validations: ["required"],
          errorColor: "#e63900",
          successColor: "#238312"
        }
      )
    ),
    /* @__PURE__ */ e.createElement(
      c,
      {
        label: I18n.t("simple_form.placeholders.credit_card.card_number"),
        required: !0
      },
      /* @__PURE__ */ e.createElement(
        B,
        {
          className: o["field-input"],
          name: k,
          placeholder: I18n.t(
            "simple_form.placeholders.credit_card.card_number"
          ),
          validations: ["required", "validCardNumber"],
          showCardIcon: { height: 15 },
          errorColor: "#e63900",
          successColor: "#238312"
        }
      )
    ),
    /* @__PURE__ */ e.createElement(
      c,
      {
        label: I18n.t("booking_engine.payment.expiry_date"),
        required: !0
      },
      /* @__PURE__ */ e.createElement(
        M,
        {
          className: o["field-input"],
          name: q,
          placeholder: I18n.t("booking_engine.payment.expiry_date"),
          validations: ["required", "validCardExpirationDate"],
          yearLength: 2,
          errorColor: "#e63900",
          successColor: "#238312"
        }
      )
    ),
    /* @__PURE__ */ e.createElement(c, { label: I18n.t("booking_engine.payment.cvc"), required: !0 }, /* @__PURE__ */ e.createElement(
      R,
      {
        className: o["field-input"],
        name: F,
        placeholder: I18n.t("booking_engine.payment.cvc"),
        validations: ["required", "validCardSecurityCode"],
        errorColor: "#e63900",
        successColor: "#238312"
      }
    )),
    /* @__PURE__ */ e.createElement(
      P,
      {
        label: I18n.t("payment_frontend.confirm_your_booking"),
        disabled: y
      }
    )
  )) : /* @__PURE__ */ e.createElement("div", null, "Loading...");
};
export {
  K as VGSElement
};
